import { action, observable, ObservableMap } from 'mobx'
import { computedFn } from 'mobx-utils'
import { ProductPriceService } from '@services/productPricesService'
import { PricesTypes } from '@constants'

export class BuyingSessionProductPricesStore {
  @observable prices = new ObservableMap()
  private apiService = new ProductPriceService()

  @action fetchPriceData = async (variables, buyingSessionGroupId, priceTypeKey) => {
    let priceData = {}
    if (!this.prices.has(priceTypeKey)) {
      await Promise.all(
        PricesTypes.filter(type => type).map(async priceType => {
          await this.apiService
            .getProductPrices(
              buyingSessionGroupId,
              variables[`${priceType}Group`],
              variables[`${priceType}Type`]
            )
            .then(prices => (priceData[priceType] = prices))
        })
      )
        .then(() => {
          this.prices.set(priceTypeKey, priceData)
        })
        .catch(() => {
          this.prices.set(priceTypeKey, null)
        })
    }
    await this.removePreviousBSGPrices(buyingSessionGroupId)
  }

  @action removePreviousBSGPrices(buyingSessionGroupId) {
    Array.from(this.prices.keys()).forEach(key => {
      if (!key.includes(buyingSessionGroupId)) {
        this.prices.delete(key)
      }
    })
  }

  getPriceByBuyingSessionAndClient = computedFn(key => this.prices.get(key))

  @action
  resetPrices() {
    this?.prices?.clear()
  }
}

export const buyingSessionProductPriceStore = new BuyingSessionProductPricesStore()
